import React from 'react';
import type { HtmlConfig } from '@/types/page';
import { getSpacingStyle } from '@/utils/pageUtils';

interface HtmlComponentProps {
  config: HtmlConfig;
}

export default function HtmlComponent({ config }: HtmlComponentProps) {
  if (!config.content) {
    return null;
  }

  // 应用 spacing 样式
  const spacingStyle = getSpacingStyle(config.spacing);

  // 直接渲染 HTML（信任后端内容）
  return (
    <div
      style={spacingStyle}
      dangerouslySetInnerHTML={{ __html: config.content }}
    />
  );
}
